import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import useNuevasOpciones from '../../hooks/parameter/useNuevasOpciones';
import useThemes from '../../hooks/useThemes';

export const SectionButtons = () => {
  const nuevasOpciones = useNuevasOpciones();
  const history = useHistory();
  const { backgroundWhite, backgroundOctavo, colorSecundario } = useThemes();
  return (
    <Container
      background={backgroundWhite}
      color={colorSecundario}
      backgroundcirculo={backgroundOctavo}
    >
      {nuevasOpciones ? (
        <>
          {nuevasOpciones.opcionesMenuNuevas.map((item, index) => (
            <div className='sub-container' key={index}>
              <Link to={`${item.rutaOpcion}`} className='item'>
                <div className='text-container'>
                  <p>{item.nombreOpcion}</p>
                </div>
              </Link>
            </div>
          ))}
        </>
      ) : (
        'loading...'
      )}
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7vh 0;

  .sub-container {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    place-items: center;

    .item {
      display: flex;
      align-items: center;
      border-radius: 10vw;
      cursor: pointer;
      background-color: ${(props) => props.background};
      box-shadow: 0 0 6px #808080;
      padding: 1.2rem 0;
      width: 80%;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.1);
        background-color: ${(props) => props.background};

        p {
          color: ${(props) => props.color};
        }
      }

      .text-container {
        margin-left: 2rem;
        width: 100%;

        p {
          font-size: 20px;
          font-weight: 700;
          line-height: 5rem;
          text-align: center;
          color: ${(props) => props.color};
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 850px) {
    flex-direction: column;
    gap: 20px;
  }

`;
